import PaintCanvas from './PaintCanvas';

export default PaintCanvas;
